import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_HOMEPAGE';

const en = {
    homepage_title: 'Priority Home Page',
    collapse_icon_tooltip: 'Collapse or expand',
    add_widgets_tooltip: 'Add widgets and portlets to your home page',
    add_portlet_title: 'Add to Home Page',
    btn_add: 'Add',
    btn_cancel: 'Cancel',
    add_group_tooltip: 'Add a new group to My Shortcuts',
    group_limit_msg: 'You can only add up to X groups.',
    shortcuts_title: 'My Shortcuts',
    shortcuts_empty_state: 'Your shortcuts will appear here.\n Click below to get started.',
    tiles_section_empty_state:
        'Your shortcuts will appear here.\n Drag and drop shortcuts, or click on the link below to add shortcuts.',
    add_shortcuts: 'Add shortcut',
    replace_tile_dialog: 'Move to group',
    replace_tile_dialog_message: 'X is already in the Y group.\n Move it to the Z group?',
    tile_exists_in_current_group_message: 'The {X} shortcut is already in this group.',
    replace_tile_dialog_confirm_label: 'Move',
    add_group_dialog_title: 'Add New Group',
    edit_group_dialog_title: 'Edit Group Name',
    add_group_dialog_content: 'Enter a name for your group',
    save_btn_label: 'Save',
    add_tile_btn: 'Add shortcut',
    add_tile_tooltip: 'Add shortcut',

    edit_group_name_label: 'Edit group name',
    delete_label: 'Delete group',
    delete_group_label_tooltip: 'Leave at least one group',
    new_group_label: 'Add new group',
    remove_group_dialog_title: 'Delete the X group',
    remove_group_dialog_content:
        'Are you sure you want to delete the X group? All the shortcuts in the group will be deleted from your home page.',
    remove_label: 'Delete',
    add_to_homepage_dialog_title: 'Add to Homepage',
    add_to_homepage_dialog_content: 'Choose the home page group you want to add this entity to.',
    group_name_exists_dialog_title: 'Group name already exists',
    group_name_exists_dialog_instructions: 'Change the name of this group.',
    group_name_exists_dialog_confirm: 'OK',

    insights_title: 'My Insights',

    add_tile_main_title: 'Add shortcut to',
    search_tiles_list_empty: 'Shortcuts will appear here. \n Use the search bar to get started.',
    search_tiles_empty_search:
        'We did not find results for your search. \n' + 'Try your search again.',
    search_tiles_input_placeholder: 'Search entities ',
    search_tiles_btn: 'Search',
    search_tiles_add_btn: 'Add to group',
    ignore_case_label: 'Ignore case',

    copy_homepage_dialog_title: 'Parameter Input - ',
    copy_homepage_dialog_sub_title: 'Copy Homepage',
    copy_from_user_label: 'From user',
    copy_to_user_label: 'To user',
    copy_insights_label: 'Insights Panel',
    copy_shortcuts_label: 'My Shortcuts Panel',
    copy_groups_label: 'Groups',
    copy_from_language_label: 'From language',
    copy_to_language_label: 'To language',
    copy_dialog_clear_btn: 'Clear',
    copy_dialog_copy_btn: 'Copy',

    portlet_open_in_window: 'Open in new a window',
    portlet_choose_dates: 'Choose dates',
    dialog_portlet_dates_title: 'Choose dates',
    portlet_choose_dates_help: 'Here you can choose the dates for the portlet',

    widget_already_exists: 'The widget already exists in the group',
    widget_list_empty: 'You already added all portlets and widgets to your home page. ',
    help_label: 'Help',
    priority_help_label: 'Priority Help',
    remove_insights_dialog_title: 'Remove group',
    remove_insights_dialog_content:
        'Are you sure you want to remove this group? \n' +
        'The widgets and portlets in the group will be removed from your home page.',
    new_group_btn: 'New group',
    greeting_morning: 'Good morning',
    greeting_afternoon_1: 'Good afternoon',
    greeting_afternoon_2: 'Good afternoon',
    greeting_evening: 'Good evening',
    greeting_night: 'Good night',
    no_privilege_tile_msg: 'You need privileges for the shortcut to use it in this company.'
};

const he = {
    homepage_title: 'דף הבית של Priority',
    collapse_icon_tooltip: 'לצמצם או להרחיב',
    add_widgets_tooltip: "הוספת ווידג'טים ופורטלטים לדף הבית",
    add_portlet_title: 'הוספה למסך הבית',
    btn_add: 'הוספה',
    btn_cancel: 'ביטול',
    add_group_tooltip: 'הוספת קבוצת קיצורי דרך חדשה',
    group_limit_msg: 'אפשר להוסיף עד X קבוצות.',
    shortcuts_title: 'קיצורי הדרך שלי',
    shortcuts_empty_state:
        'כאן יופיעו קיצורי הדרך שתגדירו.\n' + 'לחצו על “הוספת קיצורי דרך” כדי להתחיל.',
    add_shortcuts: 'הוספת קיצורי דרך',
    replace_tile_dialog: 'להעביר את קיצור הדרך?',
    replace_tile_dialog_message: 'כבר קיים קיצור דרך לישות X בקבוצה Y. להעביר אותו לקבוצה Z?',
    tile_exists_in_current_group_message: 'כבר קיים קיצור דרך עבור {X} בקבוצה הזאת. ',
    replace_tile_dialog_confirm_label: 'העברה',
    add_group_dialog_title: 'הוספת קבוצה חדשה',
    edit_group_dialog_title: 'שינוי שם קבוצה',
    add_group_dialog_content: 'רשמו שם קבוצה',
    save_btn_label: 'שמירה',
    tiles_section_empty_state:
        'כאן יופיעו קיצורי הדרך.\n' +
        'אפשר לגרור לכאן קיצורי דרך או ללחוץ על הקישור כדי להוסיף קיצורי דרך חדשים לקבוצה.',
    add_tile_btn: 'הוספת קיצורי דרך',
    add_tile_tooltip: 'להוסיף קיצורי דרך',
    edit_group_name_label: 'שינוי שם קבוצה',
    delete_label: 'מחיקת קבוצה',
    delete_group_label_tooltip: 'השאירו לפחות קבוצה אחת',
    new_group_label: 'הוספת קבוצה חדשה',
    remove_group_dialog_title: 'מחיקת קבוצה X',
    remove_group_dialog_content:
        'למחוק את הקבוצהX?\n' + 'כל קיצורי הדרך בקבוצה זו יימחקו ממסך הבית שלך.',
    remove_label: 'מחיקה',
    add_to_homepage_dialog_title: 'הוספה לדף הבית',
    add_to_homepage_dialog_content: 'בחרו את הקבוצה בדף הבית אליה תרצו להוסיף קיצור דרך לישות זו.',

    group_name_exists_dialog_title: 'שם הקבוצה כבר קיים',
    group_name_exists_dialog_instructions: 'רשמו שם אחר לקבוצה.',
    group_name_exists_dialog_confirm: 'אישור',

    insights_title: 'התובנות שלי',

    add_tile_main_title: 'הוספת קיצור דרך ל',
    search_tiles_list_empty: 'התחילו לחפש כדי לקבל רשימת קיצורי דרך.',
    search_tiles_empty_search: 'לא מצאנו תוצאות. נסו חיפוש חדש.',
    search_tiles_input_placeholder: 'התחילו לרשום שם ישות',
    ignore_case_label: 'לכלול אותיות רישיות וקטנות',
    search_tiles_btn: 'חיפוש',
    search_tiles_add_btn: 'הוספה לקבוצה',

    copy_homepage_dialog_title: 'Parameter Input - ',
    copy_homepage_dialog_sub_title: 'Copy Homepage',
    copy_from_user_label: 'From user',
    copy_to_user_label: 'To user',
    copy_insights_label: 'Insights Panel',
    copy_shortcuts_label: 'My Shortcuts Panel',
    copy_groups_label: 'Groups',
    copy_from_language_label: 'From language',
    copy_to_language_label: 'To language',
    copy_dialog_clear_btn: 'Clear',
    copy_dialog_copy_btn: 'Copy',

    widget_already_exists: 'The widget already exists in the group',

    portlet_open_in_window: 'פתיחה בחלון חדש',
    portlet_choose_dates: 'בחירת תאריכים',
    widget_list_empty: "כבר הוספת את כל הפורטלטים והווידג'טים  לדף הבית.",
    help_label: 'עזרה',
    priority_help_label: 'עזרה',
    remove_insights_dialog_title: 'הסרת קבוצה',
    remove_insights_dialog_content: 'להסיר את הקבוצה?\n' + 'הפריטים מקבוצה זו יוסרו ממסך הבית שלך.',
    new_group_btn: 'קבוצה חדשה',
    greeting_morning: 'בוקר טוב',
    greeting_afternoon_1: 'צוהריים טובים',
    greeting_afternoon_2: 'אחר צהריים טובים',
    greeting_evening: 'ערב טוב',
    greeting_night: 'לילה טוב',
    no_privilege_tile_msg: 'כדי להשתמש בקיצור הדרך צריך הרשאות בחברה זו.'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'collapse_icon_tooltip',
    2: 'add_widgets_tooltip',
    3: 'add_portlet_title',
    4: 'btn_add',
    5: 'btn_cancel',
    6: 'add_group_tooltip',
    7: 'group_limit_msg',
    8: 'shortcuts_title',
    9: 'shortcuts_empty_state',
    10: 'add_shortcuts',
    11: 'replace_tile_dialog',
    12: 'replace_tile_dialog_message',
    13: 'replace_tile_dialog_confirm_label',
    14: 'add_group_dialog_title',
    15: 'edit_group_dialog_title',
    16: 'add_group_dialog_content',
    17: 'save_btn_label',
    19: 'tiles_section_empty_state',
    20: 'add_tile_btn',
    21: 'add_tile_tooltip',
    22: 'edit_group_name_label',
    23: 'delete_label',
    24: 'delete_group_label_tooltip',
    25: 'new_group_label',
    26: 'remove_group_dialog_title',
    27: 'remove_group_dialog_content',
    28: 'remove_label',
    29: 'add_to_homepage_dialog_title',
    30: 'add_to_homepage_dialog_content',
    31: 'widget_list_empty',
    32: 'group_name_exists_dialog_title',
    33: 'group_name_exists_dialog_instructions',
    34: 'group_name_exists_dialog_confirm',
    35: 'add_tile_main_title',
    36: 'search_tiles_input_placeholder',
    37: 'ignore_case_label',
    38: 'search_tiles_empty_search',
    39: 'search_tiles_add_btn',
    40: 'search_tiles_btn',
    41: 'search_tiles_list_empty',
    42: 'portlet_open_in_window',
    43: 'portlet_choose_dates',
    44: 'tile_exists_in_current_group_message',
    45: 'help_label',
    46: 'priority_help_label',
    49: 'no_privilege_tile_msg',
    50: 'homepage_title',
    51: 'new_group_btn',
    52: 'greeting_morning',
    53: 'greeting_afternoon_1',
    54: 'greeting_evening',
    55: 'greeting_afternoon_2',
    56: 'greeting_night'
};

export async function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks according to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity] as typeof en;
